import Checkbox from '@components/Checkbox';
import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import useBottomSheet from '@hooks/ui/useBottomSheet';
import useModal from '@hooks/ui/useModal';
import { useSetAtom } from 'jotai';

import DeleteAllMyMenuModal from './DeleteAllMyMenuModal';
import { isDeletingAtom } from '../../../atoms/myMenuAtoms';

function MyMenuSettingBottomSheet() {
    const { closeBottomSheet } = useBottomSheet();
    const { openModal } = useModal();
    const setDeleting = useSetAtom(isDeletingAtom);
    const handleDeleteAll = () => {
        closeBottomSheet();
        openModal(<DeleteAllMyMenuModal/>);
    };
    const handleStartDelete = () => {
        setDeleting(true);
        closeBottomSheet();
    };
    return (
        <Container>
            <MainText fontWeight='bold' size='lg'>
                메인화면 노출
            </MainText>
            <Checkbox>전체 숨기기</Checkbox>
            <NoteBox>
                <Text color={colors.gray6}>
                    메뉴를 삭제 하지 않고 일시적으로 숨겨서 전체 리스트를 미노출시킬 수 있습니다.
                </Text>
            </NoteBox>
            <Text fontWeight='bold' size='lg'>
                메뉴 삭제
            </Text>
            <Remove spacing={12}>
                <Text onClick={handleStartDelete}>선택 삭제</Text>
                <Text onClick={handleDeleteAll}>
                    전체 삭제
                </Text>
            </Remove>
        </Container>
    );
}

const Container = styled(Column)`
    padding: 24px 20px 16px;
`;

const MainText = styled(Text)`
    margin-bottom: 16px;
`;

const NoteBox = styled.div`
    background-color: var(--color-gray2);
    border-radius: 8px;
    margin: 8px 0 24px;
    padding: 12px;
`;

const Remove = styled(Column)`
    margin-top: 16px;
`;

export default MyMenuSettingBottomSheet;
